import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Subgrupo } from '../../components'
import * as subgrupoActionCreators from '../../redux/modules/subgrupo'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class SubgrupoContainer extends Component {
  static propTypes = {
    history: PropTypes.object,
    multipleSubgrupo: PropTypes.object,
    fetchMultipleSubgrupo: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroySubgrupo: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleSubgrupo()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/subgrupos/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/subgrupos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroySubgrupo(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('subgrupo', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('subgrupo', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleSubgrupo.toList().toJSON(),
      'subgrupo',
      ['id', 'nome', 'descricao'],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <Subgrupo
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleSubgrupo={this.props.multipleSubgrupo}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({ subgrupo, status, sort, filter }) {
  const sortColumn = sort.getIn(['subgrupo', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['subgrupo', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['subgrupo', 'filterText']) || ''

  let map = filterMap(subgrupo, ['nome', 'descricao'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleSubgrupo: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['subgrupo', 'error']),
    isLoading: status.getIn(['subgrupo', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...subgrupoActionCreators,
    ...flashMessageAcionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SubgrupoContainer)
